export default __webpack_public_path__ + "static/media/Weather-App.ad5a6952.png";